import BreadCrumb from "Common/BreadCrumb";
import ToggleSwitch from "Common/ToggleSwitch";
import { useEffect, useState } from "react";
import { Container,  Form, Button,  Modal, Dropdown, Accordion,  ListGroup, Tooltip, OverlayTrigger } from "react-bootstrap";
import {  useParams } from "react-router-dom";
import { authServices } from "Utils/auth/services";
import snackbarUtil from "Utils/snackBarUtil";
import LimitSetting from "./LimitSetting";


const ImportMarketForChild = () => {
    const [marketSetting, setMarketSetting] = useState(false);
    const [showTvScore, setTvScore] = useState(false);
    const [deleteMatch, setDeleteMatch] = useState(false);
    const [showPassword, setPassword] = useState(false);
    const [sportSeries, setSportSeries] = useState<{ [key: string]: seriesRes[] }>({});
    const [sportMatches, setSportMatches] = useState<{ [key: string]: MatchesRes[] }>({});
    const [sportName, setSportName] = useState<sportList[]>([]);
    const [sportIds, setSportids] = useState<string>("");
    // eslint-disable-next-line
    const [sportNameMarket, setSportiNameMarket] = useState<string>("");
    const [limits, setLimits] = useState<LimitResponse>();
    // eslint-disable-next-line
    const [marketName, setMarkrtName] = useState<string>("");
    const [marketData, setMarketData] = useState<MatchesRes[]>([]);
     // eslint-disable-next-line
    const [seriesIdss, setSeriesids] = useState<string>();
    const [matchid, setMatchid] = useState<string>("");
    const [showNews, setShowNews] = useState<boolean>(false);
    const [newsValues, setNewsValues] = useState<string>("");
    const [seriesSearchTerm, setSeriesSearchTerm] = useState("");
    const [matchSearchTerm, setMatchSearchTerm] = useState("");
    const [tvData, setTvData] = useState<SocreTVRes>({
        match_scoreboard_url: "",
        non_premimum_match_tv_url: "",
        premimum_match_tv_url: ""
    });
    const [errors, setErrors] = useState({
        premimum_match_tv_url: '',
        non_premimum_match_tv_url: '',
        match_scoreboard_url: ''
    });


    const { id, userId: userName } = useParams();
    const getUpdateEventNews = async (data: any) => {
        const { response } = await authServices?.updateEvent({
            event: data?.eventName,
            filter: {
                [data?.sportName]: data?.sportId
            },
            update: {
                news: newsValues,
            }
        })
        if (response) {
            if (response?.status) {
                snackbarUtil.success(response?.data);
                getMarketData(data?.series_id);
            } else {
                snackbarUtil.error(response?.msg);
            }
        }

    }
    const [newsPaylod, setNewsPayload] = useState({
        sportName: "",
        eventName: "",
        sportId: "",
        series_id: ""
    })

    const toggleNews = (sportName: string, eventName: string, sportId: string, series_id: string) => {
        setShowNews(true);
        setNewsPayload((prev) => ({
            ...prev,
            sportName,
            eventName,
            sportId,
            series_id
        }))
    }


    const handleUpdateNews = () => {
        getUpdateEventNews(newsPaylod)
    }

    const getLimit = async (id: string, mrktName: string,) => {
        if (sportIds) {
            const { response } = await authServices?.getLimits({
                [mrktName]: id
            })
            setLimits(response?.data);
        }

    }

    const closeMarketSetting = () => {
        setMarketSetting(false)
    }


    const getSport = async () => {
        let payload: any = {};
        if (id) {
            payload.user_id = id;
        }
        const { response } = await authServices.getSportListData(payload);
        setSportName(response?.data);
    };

    const getSeriesData = async (sportId: string) => {
        let payload: any = {};
        payload.sport_id = sportId;
        if (id) {
            payload.user_id = id;
        }
        try {
            const { response } = await authServices.getSeriesData(payload);
            setSportSeries(prev => ({ ...prev, [sportId]: response?.data || [] }));
            setSportids(sportId)
        } catch (error) {
            console.error("Error fetching series data:", error);
        }

    }

    const handleSportSeriesData = (sportId: string, is_active: number) => {
        getSeriesData(sportId);
    };

    const getMatchesData = async (sport_id: string, series_id: string) => {
        let payload: any = {};
        payload.sport_id = sport_id;
        payload.series_id = series_id;
        if (id) {
            payload.user_id = id;
        }
        try {
            const { response } = await authServices.getMatchesData(payload);
            setSportMatches(prev => ({ ...prev, [series_id]: response?.data || [] }));
        } catch (error) {
            console.error("Error fetching matches:", error);
        }
    };



    const userDetails = localStorage.getItem("adminDetails");
    const userId = userDetails && JSON.parse(userDetails)

    const getUpdateStatus = async (is_active: number) => {
        const { response } = await authServices.getUpdateSportServices({
            is_active,
            sport_id: sportIds,
            user_typeId: userId?.user_type_id,
            userid: userId?._id
        })

        if (response?.status) {
            snackbarUtil.success(response.msg);
            getSport();
        } else {
            snackbarUtil.error(response?.msg);
        }
    }
    const handleMatches = (seriesId: string, sportId: string) => {
        getMatchesData(sportId, seriesId);
    };

    useEffect(() => {
        getSport();
        // eslint-disable-next-line
    }, []);

    const getMarketData = async (match_id: string) => {
        let payload: any = {};
        payload.sport_id = sportIds;
        payload.match_id = match_id;
        if (id) {
            payload.user_id = id;
        }
        const { response } = await authServices.getMarketData(payload);

        setMarketData(response?.data)
    }


    const handleMarketData = (matchid: string) => {
        getMarketData(matchid)
    }


    const getTvScore = async (match_id: string) => {
        const { response } = await authServices.getTvScore({
            match_id,
        })
        setTvData((prev) => ({
            ...prev,
            ...response?.data
        }));
    }
    const getUpdateScore = async () => {
        const { response } = await authServices.getUpdateUrl({
            match_id: matchid,
            update: tvData,
        })
        if (response) {
            if (response?.status) {
                snackbarUtil.success(response?.data);
                setTvScore(!showTvScore);
            } else {
                snackbarUtil.error(response?.data);
            }
        }

    }


    const handleTvScore = (id: string, name: string) => {
        setMatchid(id)
        getTvScore(id);
        setTvScore(!showTvScore);
    }

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;

        setTvData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleUpdateTv = () => {
        let newErrors = { premimum_match_tv_url: '', non_premimum_match_tv_url: '', match_scoreboard_url: '' };
        if (!tvData?.premimum_match_tv_url) {
            newErrors.premimum_match_tv_url = "Premium TV URL is required.";
        }
        if (!tvData?.non_premimum_match_tv_url) {
            newErrors.non_premimum_match_tv_url = "Normal TV URL is required.";
        }
        if (!tvData?.match_scoreboard_url) {
            newErrors.match_scoreboard_url = "Score URL is required.";
        }
        setErrors(newErrors);
        if (newErrors.premimum_match_tv_url || newErrors.non_premimum_match_tv_url || newErrors.match_scoreboard_url) {
            return;
        }
        getUpdateScore();
    };  
   


    const getEventBlock = async (event: string, mrktName: string, mid: string, sid?: string) => {
        const payload = {
            event,
            filter: {
                [mrktName]: mid,
            },
            user_id: id || ""
        };
        try {
            const { response } = await authServices.getEventBlock(payload);
            if (response) {
                if (response.status) {
                    snackbarUtil.success(response.msg);
                    getSport();
                    getSeriesData(sportIds);
                    if (sid) {
                        getMatchesData(mid, sid);
                    }
                } else {
                    snackbarUtil.error(response?.msg);
                }
            }
        } catch (error) {
            console.error("Error fetching event block data:", error);
        }
    };
    const handleActiveSport = (sport:string, sport_id: string, is_active: number,sportName:string, e: any, ids?:string) => {
        const newStatus = is_active === 1 ? 0 : 1;
        if (id) {
            getEventBlock(sport, sportName, sport_id, ids);
        } else {
            getUpdateStatus(newStatus);
        }
    };

    return (
        <div className="page-content">
            <Container fluid>
                <div className="position-relative mb-2">
                    <BreadCrumb title={id ? `Block Market (${userName})` : "Import Market"} pageTitle="Dashboard" back />
                </div>
                <Accordion defaultActiveKey='0' className="custom-accordion-border accordion-border-box accordion-dark">
                    {
                        sportName?.map((sport) => {
                            return (
                                <Accordion.Item key={sport?.name} eventKey={sport?.name} className="position-relative">
                                    <Accordion.Header onClick={() => handleSportSeriesData(sport?.sport_id, sport?.is_active)}>{sport?.name}</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="mb-2 d-flex align-items-center">
                                            <ToggleSwitch On='On' Off='Off' className="me-2" id={`match-${sport?.name}`} onChange={(e: any) => handleActiveSport("Sport",sport?.sport_id,sport?.is_active, "sport_id", e)} checked={sport?.is_active} />
                                            <div className="ms-3 w-25">
                                                <div className="form-icon">
                                                    <Form.Control value={seriesSearchTerm} onChange={(e) => setSeriesSearchTerm(e.target.value)} type="text" className="form-control form-control-icon rounded-pill" placeholder="Search Series.." />
                                                    <i className="ri-search-line"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <Accordion className="custom-accordion-border accordion-border-box accordion-dark">
                                            {
                                                sportSeries[sport.sport_id]?.filter(series => series?.name?.toLowerCase().includes(seriesSearchTerm.toLowerCase()))?.map((series) => {
                                                    return (
                                                        <Accordion.Item key={series?.series_id} eventKey={series?.name} className="position-relative">
                                                            <Accordion.Header onClick={() => handleMatches(series?.series_id, series?.sport_id)}>{series?.name} <span className="mx-2 text-muted">|</span> <span className="">{series?.match_count}</span> <span className="mx-2 text-muted">|</span> <span className="">{series?.series_id}</span>
                                                            </Accordion.Header>
                                                            <Accordion.Body>
                                                                <div className="mb-2 d-flex align-items-center">
                                                                <ToggleSwitch On='On' Off='Off' className="me-2" id={`market-${series?.series_id}`} onChange={(e: any) => handleActiveSport("Series", series?.series_id, series?.is_active,"series_id", e, series?.sport_id)} checked={series?.is_active} />
                                                                    <div className="ms-2 w-25">
                                                                        <div className="form-icon">
                                                                            <Form.Control  value={matchSearchTerm} onChange={(e) => setMatchSearchTerm(e.target.value)} type="text" className="form-control form-control-icon rounded-pill" placeholder="Search Match.." />
                                                                            <i className="ri-search-line"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <Accordion className="custom-accordion-border accordion-border-box accordion-dark">
                                                                    {
                                                                        sportMatches[series.series_id]?.filter(match => match.name.toLowerCase().includes(matchSearchTerm.toLowerCase()))?.map((matches) => {
                                                                            return (
                                                                                <Accordion.Item eventKey={matches?.match_id} className="position-relative">
                                                                                    <Accordion.Header onClick={() => handleMarketData(matches?.match_id)}>{matches?.name} <span className="mx-2 text-muted">|</span> <span className="">{matches?.match_id}</span>
                                                                                    </Accordion.Header>
                                                                                    <Accordion.Body>
                                                                                        <div className="d-flex align-items-center mb-2">
                                                                                            {/* <ToggleSwitch On="On" Off="Off" id={matches?.match_name}
                                                                                             onChange={(e: any) => handleActiveSport("Match", matches?.match_id, matches?.is_active,"match_id", e, matches?.match_id)}
                                                                                             checked={matches?.is_active} /> */}
                                                                                             <OverlayTrigger placement='top' overlay={<Tooltip id="tooltip-top"> Update TV & Score </Tooltip>}>
                                                                                                <Button variant='btn-ghost py-1 px-2 me-1' id={`series-${series?.series_id}`}
                                                                                                    onClick={() => handleTvScore(matches?.match_id, matches?.match_name)}
                                                                                                ><i className='ri-mac-line fs-xl'></i></Button>
                                                                                                       
                                                                                                </OverlayTrigger>
                                                                                            {/* <Dropdown drop="start" className="ms-3">
                                                                                                <Dropdown.Toggle variant="primary" className="e-caret-hide btn-sm">
                                                                                                    <i className="fs-lg ri-more-2-fill"></i>
                                                                                                </Dropdown.Toggle>
                                                                                                <Dropdown.Menu className="relative">
                                                                                                    <Dropdown.Item className="border-bottom py-2" onClick={() => handleTvScore(matches?.match_id, matches?.match_name)}>Update TV & Score</Dropdown.Item>
                                                                                                </Dropdown.Menu>

                                                                                            </Dropdown> */}

                                                                                        </div>
                                                                                        {
                                                                                            marketData?.map((market) => {
                                                                                                return (
                                                                                                    <ListGroup className="list-group-fill-success">
                                                                                                        <ListGroup.Item as='a' className="list-group-item-action">
                                                                                                            <div className="d-flex align-items-center">
                                                                                                                <strong className="me-3">{market?.name} <span className="mx-2">|</span> <span className="text-muted">({market?.market_id})</span> <span className="mx-2">|</span> <span className="text-muted">({market?.centralId})</span></strong>
                                                                                                                <OverlayTrigger placement='top' overlay={<Tooltip id="tooltip-top"> News </Tooltip>}>
                                                                                                <Button variant='btn-ghost py-1 px-2 me-1' id={`series-${series?.series_id}`}
                                                                                                    onClick={() => toggleNews("market_id", "market", market?.market_id, market?.match_id)}
                                                                                                ><i className=" bx bx-news fs-xl"/></Button>
                                                                                                       
                                                                                                </OverlayTrigger>
                                                                                                                {/* <Dropdown drop="start" className="ms-auto">
                                                                                                                    <Dropdown.Toggle variant="primary" className="e-caret-hide btn-sm">
                                                                                                                        <i className="fs-lg ri-more-2-fill"></i>
                                                                                                                    </Dropdown.Toggle>

                                                                                                                    <Dropdown.Menu>

                                                                                                                        <Dropdown.Item className="py-2" onClick={() => toggleNews("market_id", "market", market?.market_id, market?.match_id)}>Update News</Dropdown.Item>
                                                                                                                    </Dropdown.Menu>
                                                                                                                </Dropdown> */}
                                                                                                            </div>
                                                                                                        </ListGroup.Item>
                                                                                                    </ListGroup>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </Accordion.Body>
                                                                                </Accordion.Item>
                                                                            )
                                                                        })
                                                                    }
                                                                </Accordion>
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    )
                                                })
                                            }


                                        </Accordion>
                                    </Accordion.Body>
                                </Accordion.Item>
                            )
                        })
                    }
                </Accordion>
            </Container>

            <LimitSetting seriesIdss={seriesIdss} marketName={marketName} limits={limits} name={sportNameMarket} sportIds={sportIds} getLimit={getLimit} show={marketSetting} clickHandler={closeMarketSetting} />

            <Modal show={showTvScore}>
                <Modal.Header className="modal-title fw-bold d-flex justify-content-between pb-1">
                    <div>Update TV & Score</div>
                    <Button variant="light btn-sm" onClick={() => setTvScore(!showTvScore)}>
                        <i className="ri-close-line fs-xl align-middle"></i>
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-floating">
                        <Form.Control
                            name="premimum_match_tv_url"
                            as="textarea"
                            rows={2}
                            style={{ height: 'auto' }}
                            id="PremiumTV"
                            value={tvData?.premimum_match_tv_url}
                            placeholder="Premium TV"
                            onChange={handleInputChange}
                            isInvalid={!!errors.premimum_match_tv_url}
                        />
                        {errors.premimum_match_tv_url && <div className="text-danger">{errors.premimum_match_tv_url}</div>}
                        <Form.Label htmlFor="Content">Premium TV</Form.Label>
                    </div>
                    <div className="form-floating mt-3">
                        <Form.Control
                            name="non_premimum_match_tv_url"
                            as="textarea"
                            rows={2}
                            style={{ height: 'auto' }}
                            id="NormalTV"
                            placeholder="Normal TV"
                            value={tvData?.non_premimum_match_tv_url}
                            onChange={handleInputChange}
                            isInvalid={!!errors.non_premimum_match_tv_url}
                        />
                        {errors.non_premimum_match_tv_url && <div className="text-danger">{errors.non_premimum_match_tv_url}</div>}
                        <Form.Label htmlFor="Content">Normal TV</Form.Label>
                    </div>
                    <div className="form-floating mt-3">
                        <Form.Control
                            name="match_scoreboard_url"
                            as="textarea"
                            rows={2}
                            style={{ height: 'auto' }}
                            id="Score"
                            placeholder="Score"
                            value={tvData?.match_scoreboard_url}
                            onChange={handleInputChange}
                            isInvalid={!!errors.match_scoreboard_url}
                        />
                        {errors.match_scoreboard_url && <div className="text-danger">{errors.match_scoreboard_url}</div>}  {/* Error message */}
                        <Form.Label htmlFor="Content">Score</Form.Label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="subtle-primary" onClick={handleUpdateTv}>Update</Button>
                    <Button variant="subtle-dark" onClick={() => setTvScore(!showTvScore)}>Cancel</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={deleteMatch} onHide={() => setDeleteMatch(!deleteMatch)}>
                <Modal.Header className="modal-title fw-bold d-flex justify-content-between pb-1">
                    Delete Match
                    <Button variant="light btn-sm" onClick={() => setDeleteMatch(!deleteMatch)}>
                        <i className="ri-close-line fs-xl align-middle"></i>
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-floating">
                        <Form.Control
                            name="password"
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                        />
                        <Form.Label>Enter Password</Form.Label>
                        <Button
                            variant="link"
                            className="position-absolute end-0 top-0 bottom-0 text-decoration-none text-muted password-addon"
                            type="button"
                            id="password-addon"
                            onClick={() => setPassword(!showPassword)}
                        >
                            <i className={`${showPassword ? "ri-eye-fill" : "ri-eye-off-fill"} align-middle`}></i>
                        </Button>
                    </div>

                    <div className="form-check mt-3">
                        <Form.Check type="checkbox" id="formCheck" defaultChecked />
                        <Form.Label className="form-check-label" htmlFor="formCheck">
                            Do you want to delete all market
                        </Form.Label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="subtle-danger">Delete</Button>
                    <Button variant="subtle-dark" onClick={() => setDeleteMatch(!deleteMatch)}>Cancel</Button>
                </Modal.Footer>
            </Modal>



            <Modal show={showNews} onHide={() => setShowNews(false)} className="zoomIn" scrollable>
                <Modal.Header className="modal-title fw-bold d-flex justify-content-between pb-1">
                    <span>Update News</span>
                    <Button variant="light btn-sm" onClick={() => setShowNews(false)}>
                        <i className="ri-close-line fs-xl align-middle"></i>
                    </Button>
                </Modal.Header>
                <Modal.Body className='fs-md'>
                    <div className="form-floating">
                        <Form.Control
                            onChange={(e) => setNewsValues(e.target.value)} value={newsValues} as="textarea" rows={5} id="Content" style={{ height: 'auto' }} placeholder='Content' />
                        <Form.Label htmlFor="Content">Content</Form.Label>

                    </div>
                </Modal.Body>
                <Modal.Footer className='border-top'>
                    <Button variant='light' onClick={() => setShowNews(false)}>Cancel</Button>
                    <Button className='ms-2' onClick={handleUpdateNews}>Update</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ImportMarketForChild;